<div class="col-md-6 offset-md-3 mt-2 mb-5">
  <div class="card mt-2 mx-auto max-w-25 border-secondary" >
    <h4 class="card-header bg-primary text-center">
      <img alt="Logo" class="main-logo cursor mt-3 pb-3 mx-auto border-bottom border-dark border-2" src="assets/logo.png" routerLink="/dashboard">
      <div class="text-dark my-2">{{'login.login'| translate}}</div>
    </h4>
    <div class="card-body bg-secondary">
      <form [formGroup]="loginForm" ngNativeValidate (ngSubmit)="loginPass()">
        <div class="form-group">
          <label for="username">{{'username'|translate}}</label>
          <input type="text" formControlName="username" class="form-control" />

        </div>
        <div class="form-group">
          <label for="password">{{'password'|translate}}</label>
          <input type="password" formControlName="password" class="form-control" />
        </div>
        <div class="d-flex justify-content-center align-items-end mt-2">
          <button class="btn btn-primary px-5 " type="submit">
            {{'login.sign_in'|translate}}
          </button>
        </div>
      </form>
      <app-sso-login (loggedIn)="loginSuccess()" />
      <app-test-login-selector />
    </div>
  </div>
</div>
